<template>
  <div>
    <b-row class="m-0 pt-3 justify-content-center">
      <div  @click="$router.push('/').catch(err => {})">
       <b-img-lazy :src="require(`@/assets/logos/eatDoradoLogo.png`)" class="hover" style=" max-width: 90%; width: 300px; height: 200px" fluid alt="eatDorado Logo"></b-img-lazy>  
      </div>
    </b-row>
    <b-row class="m-0 mt-5 justify-content-center">
      <h1>Restaurant Empfehlen</h1>
    </b-row>
    <b-row class="m-0 mt-4 justify-content-center">
      
      <div style="width: 600px; max-width: 100%" class="mx-3">
        <h4 v-if="!contactFormSent" class="text-center">Hey! Mein Lieblingsrestaurant ist noch nicht dabei und ich möchte es gerne empfehlen!</h4>
        <b-alert show variant="success" v-if="contactFormSent">
          <p class="text-center m-0">Deine Empfehlung wurde erfolgreich gesendet, vielen Dank!</p>
        </b-alert>
      <b-form class="mt-3" @submit.prevent="submitForm()">
        <b-form-group
        label="Dein Name:"
        >
          <b-form-input
            :state="form.name ? true : false"
            v-model="form.name"
            type="text"
            required
          ></b-form-input>
        </b-form-group>

        <b-form-group
        label="Deine E-Mail-Adresse:"
        >
          <b-form-input
            :state="form.email ? true : false"
            v-model="form.email"
            type="email"
            required
          ></b-form-input>
        </b-form-group>

        <b-form-group
          label="Deine Postleitzahl:"
        >
          <b-form-input
            :state="form.zipcode ? true : false"
            v-model="form.zipcode"
            type="text"
            required
          ></b-form-input>
        </b-form-group>
          <b-form-group
          label="Deine Stadt:"
        >
          <b-form-input
            :state="form.city ? true : false"
            v-model="form.city"
            type="text"
            required
          ></b-form-input>
        </b-form-group>

        <b-form-group
        label="Name des Restaurants:"
        >
          <b-form-input
            :state="form.restaurantname ? true : false"
            v-model="form.restaurantname"
            type="text"
            required
          ></b-form-input>
        </b-form-group>
        
        <b-form-group
        label="Anmerkungen:"
        >
        <b-form-textarea
          id="textarea"
          v-model="form.message"
          rows="3"
          max-rows="6"
        ></b-form-textarea>
        </b-form-group>

        <b-form-group >
          <b-form-checkbox-group
            :state="!form.checked > 0 ? false : true"
            v-model="form.checked"
            id="checkboxes-4"
            required
          >
          <b-form-checkbox value="me"><a href="/datenschutz" target="_blank">Datenschutz</a> gelesen und akzeptiert</b-form-checkbox>
        </b-form-checkbox-group>
        </b-form-group>

        <b-button type="submit" style="width: 100%" size="md" variant="dark">Senden</b-button>

      </b-form>
      </div>
    </b-row>
    <Footer></Footer>
  </div>
</template>

<script>

import Footer from '@/components/Footer'
import coreData from '@/mixins/coreDataMixin'

export default {
  name: 'Empfehlung',
  mixins: [coreData],
  data: () => {
    return {
      form: {},
    }
  },
  components: {
    Footer
  },
  computed: {
    darkMode(){
      return this.$store.getters.darkMode
    },
    contactFormSent(){
      return this.$store.getters.contactFormSent
    }
  },
  watch:{
    contactFormSent(){
      if(this.contactFormSent){
        this.form = {}
      }
    }
  },
  mounted() {
  },
  methods: {
    submitForm(){
      this.$store.dispatch('sendContactForm', this.form)
    } 
  }
}
</script>